module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty5.13f58224.jpg";